module.exports = __webpack_public_path__ + "static/002-0004619fe60d1c150487db6a921ba0ee.jpg";